var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinocularsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#84D5DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 14.25C31.5 13.875 31.125 13.5 30.75 13.5H27.75C27.3281 13.5 27 13.875 27 14.25V16.5H31.5V14.25ZM14.9531 19.5C14.8594 23.9062 12.1406 24.8906 12 30.9375V33C12 33.8438 12.6562 34.5 13.5 34.5H18C18.7969 34.5 19.5 33.8438 19.5 33V25.5H21V18H16.4531C15.6562 18 15 18.7031 14.9531 19.5ZM33 19.5C32.9531 18.7031 32.2969 18 31.5 18H27V25.5H28.5V33C28.5 33.8438 29.1562 34.5 30 34.5H34.5C35.2969 34.5 36 33.8438 36 33V30.9375C35.8125 24.8906 33.0938 23.9062 33 19.5ZM20.25 13.5H17.25C16.8281 13.5 16.5 13.875 16.5 14.25V16.5H21V14.25C21 13.875 20.625 13.5 20.25 13.5ZM22.5 25.5H25.5V18H22.5V25.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinocularsIcon);
export default __webpack_public_path__ + "static/media/binoculars_icon.ebb09ac6ea1bb2d36bf4ffdbd5ccc4f4.svg";
export { ForwardRef as ReactComponent };